import React, { useEffect } from 'react'
import {
  Redirect,
  Route,
  Switch,
  Router,
  useParams,
  useLocation,
} from 'react-router'

import { userLogin } from 'store/user/actions'

import { useSearchParams } from 'react-router-dom'

import AdminLayout from 'layouts/Admin.js'
import RTLLayout from 'layouts/RTL.js'
import AuthLayout from 'layouts/Auth.js'
import CourseLayout from 'layouts/Course'
import { useDispatch, useSelector } from 'react-redux'
import { getUserLanguage } from 'store/ConfigurationSettings/LanguageConfig/actions'
import { getLanguages } from 'store/ConfigurationSettings/LanguageConfig/actions'
import { getAllLanguages } from 'store/ConfigurationSettings/LanguageConfig/actions'
import { fetchTheme } from 'store/ConfigurationSettings/ThemeConfig/actions'
import { fetchGeneralSettings } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { fetchGroups } from 'store/Group/actions'
import { fetchCourseSettings } from 'store/ConfigurationSettings/CourseConfig/actions'
import { fetchUserProgress } from 'store/Course/actions'
import { fetchLocationGroups } from 'store/ManagerReport/actions'
import history from 'utils/history'
import ResetPassword from 'views/pages/Login/resetPassword'
import PublicCatalog from 'views/pages/PublicCatalog'
import Signup from 'views/pages/Login/signup'
import Recruitment from 'views/pages/Recruitment/Recruitment'
import AreYouSureModal from 'views/pages/Recruitment/AreYouSureModal'
import AlertModal from 'views/pages/Recruitment/AlertModal'
import { updateUserLastActivity } from 'store/user/actions'
import SuspendedScreen from 'components/SuspendedScreen'

function Main() {
  //-----------------------------------------------------------------------
  // This useEffect prevents a specific full-screen, dynamically injected iframe from blocking page interaction.
  // Safe to remove if it interferes with any legitimate features.
  // //-----------------------------------------------------------------------
  // useEffect(() => {
  //   const observer = new MutationObserver((mutations) => {
  //     mutations.forEach((mutation) => {
  //       mutation.addedNodes.forEach((node) => {
  //         if (
  //           node.tagName === 'IFRAME' &&
  //           node.style.position === 'fixed' &&
  //           node.style.zIndex === '2147483647' &&
  //           node.style.width === '100%' &&
  //           node.style.height === '100%'
  //         ) {
  //           node.style.display = 'none'
  //           // node.sandbox = 'allow-scripts'
  //           console.log('Blocked full-screen iframe:', node)
  //         }
  //       })
  //     })
  //   })

  //   observer.observe(document.body, { childList: true, subtree: true })

  //   return () => observer.disconnect()
  // }, [])
  // // -------------------------------------------------------------------

  // const isAuthed = useSelector((state) => state.auth.isAuthenticated)
  const dispatch = useDispatch()

  const { showAreYouSureModal, showAlertModal } = useSelector(
    (store) => store.recruitment,
  )

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const token = searchParams.get('token')
  const isPreviewMode =
    searchParams.get('preview') === 'true' &&
    location.pathname === '/auth/login'

  if (token) {
    localStorage.setItem('token', token)
    localStorage.setItem('top_proxy', token)
    history.push('/dashboard')
    dispatch(
      userLogin(() => {
        history.push('/dashboard')
      }),
    )
  }

  const isAuthed = useSelector((state) => state.auth.isAuthenticated)
  const currentUser = useSelector((store) => store.auth.user)
  const isSuspended = useSelector(
    (state) => state.generalConfig.suspended === 1,
  )

  const mustChangePassword =
    isAuthed &&
    currentUser &&
    currentUser.last_login == null &&
    currentUser.last_activity == null

  useEffect(() => {
    if (isAuthed && !mustChangePassword) {
      if (localStorage.getItem('top_proxy') === localStorage.getItem('token')) {
        dispatch(updateUserLastActivity())
      }
    }
  }, [isAuthed, dispatch, mustChangePassword])

  useEffect(() => {
    // React 18 fix: async function inside useEffect
    const fetchData = async () => {
      dispatch(fetchTheme())
      if (isAuthed) {
        dispatch(getUserLanguage())
        // dispatch(getLanguages())
        dispatch(getAllLanguages())
        dispatch(fetchGroups())
        dispatch(fetchCourseSettings())
        dispatch(fetchGeneralSettings())
        // dispatch(fetchLocationGroups())
      }
    }
    fetchData()
  }, [isAuthed, dispatch])

  useEffect(() => {
    if (isAuthed && location.pathname !== '/dashboard') {
      dispatch(fetchUserProgress())
    }
  }, [dispatch, isAuthed, location.pathname])

  useEffect(() => {
    if (window.location.href.includes('cabobobs')) {
      document.title = "Cabo Bob's Training"
    }
  }, [])

  console.log(isAuthed, currentUser, 'leart132')

  if (isAuthed && isSuspended) {
    return <SuspendedScreen />
  }

  return (
    <Router history={history}>
      <Switch>
        {/* Preview Mode: show login page only */}
        {isPreviewMode && (
          <Route
            exact
            path='/auth/login'
            component={require('views/pages/Login').default}
          />
        )}

        {/* Force-change-password flow must intercept all routes first */}
        {!isPreviewMode && mustChangePassword && (
          <Route
            path='/'
            component={
              require('./views/pages/Auth/ForceChangePassword').default
            }
          />
        )}

        {/* These routes are always accessible regardless of auth state */}
        {!isPreviewMode && (
          <Route path='/reset-password' component={ResetPassword} />
        )}
        {!isPreviewMode && (
          <Route path='/auth/signup' component={Signup} />
        )}

        {/* Public routes accessible without login */}
        {!isPreviewMode && !isAuthed && location.pathname.includes('/public-catalog') && (
          <Route path='/public-catalog' component={PublicCatalog} />
        )}
        {!isPreviewMode && !isAuthed && location.pathname.includes('/job/career') && (
          <Route path='/job/career' component={Recruitment} />
        )}
        {!isPreviewMode && !isAuthed && location.pathname.includes('/job/ai-interview') && (
          <Route path='/job/ai-interview' component={Recruitment} />
        )}

        {/* Auth layout for unauthenticated users (/auth/login, /auth/forgot-password, etc.) */}
        {!isPreviewMode && !isAuthed && (
          <Route path='/auth' render={(props) => <AuthLayout {...props} />} />
        )}

        {/* Main app for authenticated users */}
        {!isPreviewMode && isAuthed && !mustChangePassword && (
          <Route path='/' render={(props) => <AdminLayout {...props} />} />
        )}

        {/* Catch-all: send unauthenticated users to login */}
        {!isPreviewMode && !isAuthed && (
          <Redirect from='*' to={`/auth/login${location.search}`} />
        )}
      </Switch>
      {showAreYouSureModal.show && <AreYouSureModal />}
      {showAlertModal.show && <AlertModal />}
    </Router>
  )
}

export default Main
